var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoUmbra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 93.592,
    height: 40,
    viewBox: "0 0 93.592 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3, .cls-7 {\r\n        fill: #f1f4f9;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #494949;\r\n      }\r\n\r\n      .cls-4, .cls-5, .cls-6, .cls-7 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #666;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #7a7a7a;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1959",
    "data-name": "Rectangle 1959",
    className: "cls-1",
    width: 93.592,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3539",
    "data-name": "Group 3539",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3538",
    "data-name": "Group 3538",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    className: "cls-3",
    d: "M51.265,2.892c0,1.3-.943,2.088-2.5,2.088H47.126V6.91h-.647V.8h2.288c1.555,0,2.5.786,2.5,2.1m-.646,0c0-.978-.646-1.537-1.869-1.537H47.126V4.412H48.75c1.223,0,1.869-.559,1.869-1.52",
    transform: "translate(-25.041 -0.429)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    className: "cls-3",
    d: "M58.541,6.346a2.336,2.336,0,0,1,4.673,0,2.336,2.336,0,1,1-4.673,0m4.044,0a1.709,1.709,0,1,0-3.415,0,1.709,1.709,0,1,0,3.415,0",
    transform: "translate(-31.54 -2.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    className: "cls-3",
    d: "M76.947,4.091,75.209,8.685h-.585l-1.45-3.764L71.724,8.685h-.586L69.409,4.091H70l1.441,3.9,1.476-3.9h.533l1.467,3.9,1.459-3.9Z",
    transform: "translate(-37.395 -2.204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    className: "cls-3",
    d: "M90.951,6.538H87.108a1.7,1.7,0,0,0,1.808,1.6,1.81,1.81,0,0,0,1.406-.6l.35.4a2.429,2.429,0,0,1-4.184-1.589,2.213,2.213,0,0,1,2.244-2.332A2.19,2.19,0,0,1,90.96,6.346c0,.053-.009.123-.009.192m-3.843-.463h3.257a1.632,1.632,0,0,0-3.257,0",
    transform: "translate(-46.596 -2.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    className: "cls-3",
    d: "M101.243,4.015v.6c-.052,0-.1-.009-.148-.009A1.486,1.486,0,0,0,99.549,6.3V8.644h-.62V4.05h.594v.9a1.732,1.732,0,0,1,1.72-.934",
    transform: "translate(-53.299 -2.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    className: "cls-3",
    d: "M109.736,6.538h-3.843a1.7,1.7,0,0,0,1.808,1.6,1.81,1.81,0,0,0,1.406-.6l.35.4a2.429,2.429,0,0,1-4.184-1.589,2.213,2.213,0,0,1,2.244-2.332,2.19,2.19,0,0,1,2.228,2.332c0,.053-.009.123-.009.192m-3.843-.463h3.257a1.632,1.632,0,0,0-3.257,0",
    transform: "translate(-56.717 -2.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    className: "cls-3",
    d: "M121.364,0V6.48h-.594V5.572A1.991,1.991,0,0,1,119,6.524a2.23,2.23,0,0,1-2.288-2.341A2.223,2.223,0,0,1,119,1.851a2.006,2.006,0,0,1,1.747.909V0Zm-.611,4.183a1.709,1.709,0,1,0-3.415,0,1.709,1.709,0,1,0,3.415,0",
    transform: "translate(-62.878 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    className: "cls-3",
    d: "M140.166,4.183a2.23,2.23,0,0,1-2.288,2.341,1.991,1.991,0,0,1-1.773-.952V6.48h-.594V0h.62V2.76a2.007,2.007,0,0,1,1.747-.909,2.222,2.222,0,0,1,2.288,2.332m-.62,0a1.714,1.714,0,1,0-3.424,0,1.714,1.714,0,1,0,3.424,0",
    transform: "translate(-73.008 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    className: "cls-3",
    d: "M150.66,4.091l-2.3,5.144c-.385.9-.874,1.188-1.529,1.188a1.573,1.573,0,0,1-1.118-.42L146,9.541a1.147,1.147,0,0,0,.839.35c.41,0,.69-.192.952-.768l.2-.446-2.053-4.585h.647l1.73,3.9,1.729-3.9Z",
    transform: "translate(-78.506 -2.204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    className: "cls-3",
    d: "M187.514,56.635l-5.723-12.529a.218.218,0,0,0-.217-.126h-1.227a.218.218,0,0,0-.217.126l-5.741,12.529c-.055.126,0,.217.125.217H177.1a.2.2,0,0,0,.2-.127L178,55.234l.006-.013,1.444-3.237,0-.009.006-.015.1-.212,1.278-2.84a.131.131,0,0,1,.252,0l1.354,3.052c.054.126,0,.216-.127.216H180.37l-1.2,2.707h4.409a.2.2,0,0,1,.2.127l.813,1.715a.219.219,0,0,0,.216.127h2.582c.127,0,.181-.091.127-.217",
    transform: "translate(-93.943 -23.695)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    className: "cls-3",
    d: "M87.871,52.529V61.5h3.078v-4.27Z",
    transform: "translate(-47.341 -28.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    className: "cls-3",
    d: "M101.255,43.991V56.9h-3.08V51.381c0-.163-.125-.218-.216-.091l-3.217,4.69h0l-.023.032h0a.213.213,0,0,1-.327,0l-.029-.041-2.618-3.823-.031-.046-1.72-2.618-2.123-3.264V43.991h1.665a.245.245,0,0,1,.235.108l4.605,7.075a.215.215,0,0,0,.176.095.209.209,0,0,0,.177-.092L99.354,44.1a.246.246,0,0,1,.236-.108Z",
    transform: "translate(-47.342 -23.701)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    className: "cls-3",
    d: "M131.732,50.3c-.127-.072-.127-.128-.019-.2a2.786,2.786,0,0,0,1.069-2.318c0-2.374-1.413-3.731-4.021-3.731h-5.2V56.962h5.74c2.609,0,4.022-1.358,4.022-3.731a3.2,3.2,0,0,0-1.593-2.933M129.3,54.245h-2.48a.171.171,0,0,1-.182-.18V46.947a.171.171,0,0,1,.182-.18h1.937a1.209,1.209,0,0,1,1.3,1.194,1.2,1.2,0,0,1-1.3,1.177h-1.2v2.717H129.3a1.2,1.2,0,1,1,0,2.391",
    transform: "translate(-66.572 -23.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    className: "cls-3",
    d: "M158.356,52.723a.179.179,0,0,1,.055-.255,4.36,4.36,0,0,0,2.208-3.875,4.547,4.547,0,0,0-4.69-4.546h-5.706V56.961H153.3v-10.2h2.265a1.834,1.834,0,1,1,0,3.657h-1.216a.238.238,0,0,0-.213.346l1.719,3.383.021.042,1.354,2.641a.221.221,0,0,0,.218.127h2.933c.127,0,.2-.091.127-.216Z",
    transform: "translate(-80.935 -23.731)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    className: "cls-3",
    d: "M69.271,43.989h-2.9v7.354c-.053,2.03-1.05,2.9-2.643,2.9-1.631,0-2.662-.887-2.662-2.9V43.989h-3.08v7.354c0,2.427,1.141,5.615,5.742,5.615,4.581,0,5.723-3.188,5.723-5.615V43.989Z",
    transform: "translate(-31.241 -23.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    className: "cls-3",
    d: "M58.366,80.942h-.307a.048.048,0,0,1-.051-.051V77.347a.048.048,0,0,1,.051-.051h.307a.048.048,0,0,1,.051.051v3.544a.048.048,0,0,1-.051.051",
    transform: "translate(-31.252 -41.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    className: "cls-3",
    d: "M71.51,80.942h-.22a.073.073,0,0,1-.061-.03L69.183,78.14c-.036-.046-.062-.02-.062.026v2.725a.048.048,0,0,1-.051.051h-.307a.048.048,0,0,1-.051-.051V77.347a.048.048,0,0,1,.051-.051h.215a.072.072,0,0,1,.061.031L71.091,80.1c.036.046.061.02.061-.026V77.347A.048.048,0,0,1,71.2,77.3h.307a.048.048,0,0,1,.051.051v3.544a.048.048,0,0,1-.051.051",
    transform: "translate(-37.02 -41.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    className: "cls-3",
    d: "M86.44,77.347v.271a.048.048,0,0,1-.051.051h-.9a.048.048,0,0,0-.051.051v3.171a.048.048,0,0,1-.051.051h-.307a.048.048,0,0,1-.051-.051V77.72a.048.048,0,0,0-.051-.051h-.91a.048.048,0,0,1-.051-.051v-.271a.048.048,0,0,1,.051-.051h2.326a.048.048,0,0,1,.051.051",
    transform: "translate(-45.262 -41.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    className: "cls-3",
    d: "M100.618,80.621v.271a.048.048,0,0,1-.051.051h-2a.049.049,0,0,1-.051-.051V77.348a.048.048,0,0,1,.051-.051h1.953a.048.048,0,0,1,.051.051v.271a.048.048,0,0,1-.051.051H98.971a.048.048,0,0,0-.051.051v1.207a.048.048,0,0,0,.051.051h1.11a.049.049,0,0,1,.051.051V79.3a.048.048,0,0,1-.051.051h-1.11a.049.049,0,0,0-.051.051v1.115a.048.048,0,0,0,.051.051h1.6a.048.048,0,0,1,.051.051",
    transform: "translate(-53.074 -41.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    className: "cls-3",
    d: "M112.357,80.892V77.348a.048.048,0,0,1,.051-.051h1.319a1.2,1.2,0,0,1,.6,2.27.049.049,0,0,0-.015.071l.644,1.243c.02.036,0,.061-.036.061h-.338a.068.068,0,0,1-.061-.036l-.6-1.176a.067.067,0,0,0-.061-.036h-1.043a.048.048,0,0,0-.051.051v1.146a.049.049,0,0,1-.051.051h-.307a.048.048,0,0,1-.051-.051m1.437-1.575a.8.8,0,0,0,.782-.823.789.789,0,0,0-.885-.823h-.875a.048.048,0,0,0-.051.051v1.544a.048.048,0,0,0,.051.051Z",
    transform: "translate(-60.534 -41.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    className: "cls-3",
    d: "M128.415,77.3h.179a.062.062,0,0,1,.061.036l1.5,3.549c.015.036,0,.061-.036.061h-.3a.062.062,0,0,1-.061-.036l-.322-.757a.056.056,0,0,0-.056-.036h-1.754a.063.063,0,0,0-.061.036l-.322.757a.056.056,0,0,1-.056.036h-.3c-.036,0-.051-.025-.036-.061l1.5-3.549a.062.062,0,0,1,.061-.036m-.613,2.439h1.406c.036,0,.051-.025.036-.061l-.7-1.683a.037.037,0,0,0-.072,0l-.706,1.683c-.015.036,0,.061.036.061",
    transform: "translate(-68.339 -41.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    className: "cls-3",
    d: "M145.045,79.916l.292.041c.03.005.025.041.02.066a1.531,1.531,0,0,1-1.437.91,1.843,1.843,0,0,1,0-3.682,1.541,1.541,0,0,1,1.437.915c.005.026.021.056-.02.061l-.292.041c-.03.005-.056.015-.072-.02a1.206,1.206,0,0,0-1.064-.619,1.471,1.471,0,0,0,0,2.93,1.209,1.209,0,0,0,1.064-.624c.015-.036.046-.025.072-.02",
    transform: "translate(-76.594 -41.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    className: "cls-3",
    d: "M160.326,77.347v.271a.048.048,0,0,1-.051.051h-.9a.048.048,0,0,0-.051.051v3.171a.048.048,0,0,1-.051.051h-.307a.048.048,0,0,1-.051-.051V77.72a.048.048,0,0,0-.051-.051h-.91a.048.048,0,0,1-.051-.051v-.271a.048.048,0,0,1,.051-.051h2.326a.048.048,0,0,1,.051.051",
    transform: "translate(-85.069 -41.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    className: "cls-3",
    d: "M172.865,80.942h-.307a.048.048,0,0,1-.051-.051V77.347a.048.048,0,0,1,.051-.051h.307a.048.048,0,0,1,.051.051v3.544a.048.048,0,0,1-.051.051",
    transform: "translate(-92.94 -41.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    className: "cls-3",
    d: "M184.166,80.942h-.179a.062.062,0,0,1-.061-.036l-1.437-3.549c-.016-.036,0-.061.036-.061h.312a.055.055,0,0,1,.056.036l1.146,2.92c.02.036.056.036.072,0l1.146-2.92a.055.055,0,0,1,.056-.036h.312c.036,0,.051.026.036.061l-1.432,3.549a.061.061,0,0,1-.061.036",
    transform: "translate(-98.315 -41.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    className: "cls-3",
    d: "M200.432,80.621v.271a.048.048,0,0,1-.051.051h-2a.049.049,0,0,1-.051-.051V77.348a.048.048,0,0,1,.051-.051h1.953a.048.048,0,0,1,.051.051v.271a.048.048,0,0,1-.051.051h-1.544a.048.048,0,0,0-.051.051v1.207a.048.048,0,0,0,.051.051h1.11a.049.049,0,0,1,.051.051V79.3a.048.048,0,0,1-.051.051h-1.11a.049.049,0,0,0-.051.051v1.115a.048.048,0,0,0,.051.051h1.6a.048.048,0,0,1,.051.051",
    transform: "translate(-106.85 -41.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    className: "cls-4",
    d: "M11.409,51.259l0,6.586v6.287a1.722,1.722,0,0,1-.858-.231L.859,58.308A1.723,1.723,0,0,1,0,56.9L0,45.5a1.731,1.731,0,0,1,.211-.707l5.492,3.172Z",
    transform: "translate(0 -24.132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    className: "cls-5",
    d: "M28.722,53.819v4.062a4,4,0,0,1-3.992,3.983l0-5.742Z",
    transform: "translate(-13.324 -28.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    className: "cls-5",
    d: "M36.14,45.546l0,11.409a1.72,1.72,0,0,1-.856,1.359l-9.687,5.593a1.734,1.734,0,0,1-.866.231V60.549a7.512,7.512,0,0,0,7.443-7.525V46.971l3.759-2.166a1.736,1.736,0,0,1,.211.741",
    transform: "translate(-13.322 -24.139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    className: "cls-6",
    d: "M22.857,37.258l-5.495,3.168-5.7,3.292-5.7-3.3L.464,37.252A1.735,1.735,0,0,1,.83,36.8l10.024-5.784a1.619,1.619,0,0,1,1.618,0l10.03,5.8a1.736,1.736,0,0,1,.356.45",
    transform: "translate(-0.25 -16.592)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    className: "cls-3",
    d: "M19.242,43.28l-2.023-1.169,3.472-1.983,3.453,2-1.73,1-1.723,1Z",
    transform: "translate(-9.277 -21.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    className: "cls-7",
    d: "M21.862,47.415l-1.642.937L18.384,49.4l1.639.949h0l0,0,.01,0v4.083A3.977,3.977,0,0,1,16.046,58.4h0a3.992,3.992,0,0,1-3.983-3.986V50.331l.01-.005,0,0h0l1.639-.949-1.836-1.05-1.642-.937-1.616.941,0,0-.009.005v6.088a7.5,7.5,0,0,0,7.321,7.514h.207a7.481,7.481,0,0,0,7.349-7.488V48.364Z",
    transform: "translate(-4.64 -25.531)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUmbra);
export default __webpack_public_path__ + "static/media/LogoUmbra.3e21eab2858bb5156f40f8deedab0a01.svg";
export { ForwardRef as ReactComponent };